export default "__VITE_PUBLIC_ASSET__a96777fc__"